import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServiceBroadcast } from '../../../../core/models/serviceBroadcast';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { HeaderService } from '../../../../core/services/header.service';

@Component({
  selector: 'app-service-broadcast',
  templateUrl: './service-broadcast.component.html',
  styleUrls: ['./service-broadcast.component.scss']
})
export class ServiceBroadcastComponent implements OnInit {

  constructor(
    private dialog: MatDialogRef<ServiceBroadcastComponent>,
    private snackBar: MatSnackBar,
    private configEntityService: ConfigEntityService,
    private headerService: HeaderService
  ) { }

  serviceBroadcastForm: UntypedFormGroup;
  minDate = new Date(new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000);
  maxDate = new Date(new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000);
  depName: string[] = this.headerService.getQuickAccessDeploymentNames();
  updateServiceBroadcast: boolean = false;
  allActiveServiceBroadcastList: ServiceBroadcast[] = [];
  selectedServiceBroadcastToUpdate: ServiceBroadcast = null;

  ngOnInit(): void {
    this.depName?.unshift("all");
    this.serviceBroadcastForm = new UntypedFormGroup({
      id: new UntypedFormControl(),
      title: new UntypedFormControl(null, [Validators.required]),
      message: new UntypedFormControl(null, [Validators.required]),
      expirationTime: new UntypedFormControl(null),
      deploymentUsersToShow: new UntypedFormControl(null, [Validators.required]),
      status: new UntypedFormControl()
    })
    this.maxDate.setDate(this.minDate.getDate() + 7)

    this.serviceBroadcastForm.controls['deploymentUsersToShow'].setValue(this.depName ? [this.depName[0]] : ["all"]);

    this.configEntityService.getServiceBroadcasts()
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.allActiveServiceBroadcastList = JSON.parse(JSON.stringify(data))
            if (this.allActiveServiceBroadcastList) {
              //this.selectedServiceBroadcastToUpdate = this.allActiveServiceBroadcastList[0];
            }
          }
        },
        error: (err) => {

        }
      })
  }

  onClose() {
    this.dialog.close(false);
  }

  addServiceBroadcast(form) {
    if (form.status == 'INVALID') {
      this.serviceBroadcastForm.markAllAsTouched();
      return;
    }
    const serviceBroadcast: ServiceBroadcast = {
      title: form.value?.title,
      message: form.value?.message,
      deployment: form.value?.deploymentUsersToShow?.toString(),
      id: null,
      postedBy: "",
      status: "active",
      expirationTime: form.value?.expirationTime
        ? new Date(
          form.value?.expirationTime?.getTime() -
          (330 +
            form.value?.expirationTime?.getTimezoneOffset()) *
          60000
        )
          ?.toISOString()
          ?.split(".")[0]
        : null,
    };
    this.configEntityService.addServiceBroadcast(serviceBroadcast)
      .subscribe({
        next: (data: any) => {
          this.dialog.close(data?.message);
        },
        error: (err) => {
          this.dialog.close(err?.message);
        }
      })
  }

  valueChanged() {
    this.serviceBroadcastForm.controls["expirationTime"].setValue(
      null
    );
    this.serviceBroadcastForm.controls["expirationTime"].setValue(
      new Date(new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000)
    );
  }

  changeFormToUpdateServiceBroadcast() {
    this.updateServiceBroadcast = true;
  }

  updateActiveServiceBroadcasts(form) {
    let title = form.value?.title;
    if (!title) {
      this.snackBar.open("Please select title", "Ok", { duration:3000 });
      this.serviceBroadcastForm.markAllAsTouched();
      return;
    }
    if (form.status == 'INVALID') {
      this.serviceBroadcastForm.markAllAsTouched();
      return;
    }
    if (!this.selectedServiceBroadcastToUpdate?.id) {
      this.snackBar.open("Please select title", "Ok", { duration: 3000 });
      this.serviceBroadcastForm.markAllAsTouched();
      return;
    }
    else {
      let getTime = true;
      if (form.value?.expirationTime) {
        const dateFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
        getTime = !dateFormatRegex.test(form.value?.expirationTime);
      }
      const serviceBroadcast: ServiceBroadcast = {
        title: form.value?.title,
        message: form.value?.message,
        deployment: form.value?.deploymentUsersToShow?.toString(),
        id: this.selectedServiceBroadcastToUpdate?.id,
        postedBy: "",
        status: form.value?.status?.toString(),
        expirationTime: getTime ? form.value?.expirationTime
          ? new Date(
            form.value?.expirationTime?.getTime() -
            (330 +
              form.value?.expirationTime?.getTimezoneOffset()) *
            60000
          )
            ?.toISOString()
            ?.split(".")[0]
          : null : form.value?.expirationTime,
      };
      this.configEntityService.updateServiceBroadcast(serviceBroadcast)
        .subscribe({
          next: (data: any) => {
            this.dialog.close(data?.message);
          },
          error: (err) => {
            this.dialog.close(err?.message);
          }
        })
    }
  }

  optionClicked(value: string) {
    this.selectedServiceBroadcastToUpdate = this.allActiveServiceBroadcastList.find(x => x.id == value)
    if (this.selectedServiceBroadcastToUpdate) {
      this.serviceBroadcastForm.controls['title'].setValue(this.selectedServiceBroadcastToUpdate?.title);
      this.serviceBroadcastForm.controls['message'].setValue(this.selectedServiceBroadcastToUpdate?.message);
      this.serviceBroadcastForm.controls['expirationTime'].setValue(this.selectedServiceBroadcastToUpdate?.expirationTime);
      this.serviceBroadcastForm.controls['deploymentUsersToShow'].setValue(this.selectedServiceBroadcastToUpdate?.deployment?.split(','));
      this.serviceBroadcastForm.controls['status'].setValue(this.selectedServiceBroadcastToUpdate?.status);
    }
    else {

    }
  }

  depSelectionChange(dep) {
    if (this.serviceBroadcastForm.controls['deploymentUsersToShow']?.value?.length === 0) {
      return false; // enable all options if no option selectes
    }
    if (this.serviceBroadcastForm.controls['deploymentUsersToShow']?.value?.includes('all')) {
      return dep !== 'all'; // disable all options except 'all' if 'all' is selected
    } else if (!this.serviceBroadcastForm.controls['deploymentUsersToShow']?.value?.includes('all')) {
      return dep === 'all'; // disable 'all' if other than 'all' selected
    }
    return false;
  }
}
